import { glass, LandingSection, Reveal } from "@/components/landing/reveal";
import { FolderGit2, ListChecks, Radio } from "lucide-react";

const POINTS = [
  {
    Icon: ListChecks,
    title: "Spec lives on the board",
    body: "Requirements sit on the same Mission as the KiCad tree — not a slide deck that drifts after the first layout pass.",
  },
  {
    Icon: FolderGit2,
    title: "Reviews hang on git refs",
    body: "from_ref ↔ to_ref Design Reviews carry circuit_diff and findings. Feedback is an object, not a PDF in a thread.",
  },
  {
    Icon: Radio,
    title: "Mission control, not a second CAD",
    body: "Think and Jobs run the guided loop. KiCad stays hardware SoT. We do not generate the schematic or fight the editor.",
  },
] as const;

export function LandingProblem() {
  return (
    <LandingSection
      id="why"
      eyebrow="Why Mission"
      title="Hardware still ships as PDF threads."
      lede="Guided collab puts Spec, review, and firmware on one Mission — for teams that already have a board, without replacing the CAD they draw it in."
    >
      <div className="grid gap-3 sm:grid-cols-3">
        {POINTS.map((point, i) => (
          <Reveal key={point.title} delay={0.06 * i}>
            <article className={`${glass} h-full p-5`}>
              <point.Icon className="mb-4 size-4 text-falcon" aria-hidden />
              <h3 className="mb-2 text-[15px] font-semibold tracking-[0.01em] text-white">{point.title}</h3>
              <p className="m-0 text-[14px] leading-[1.55] text-white/64">{point.body}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </LandingSection>
  );
}
